import { isNil } from "lodash";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import ImmutablePropTypes from "react-immutable-proptypes";

import { withContainerContext } from "../../components/container/ContainerContext";
// import { CONTEXT_BAR_CONTENT_PADDING, TIMELINE_CONTEXT_OVERSCROLL } from "../../constants";
import { TIMELINE_CONTEXT_OVERSCROLL } from "../../constants";
import { immutableRecords, PropTypeShapes } from "../../types";
import selectors from "./selectors";
// import { scalePixelsToFontSize } from "../../constants/styles/dimensions";

const LISTENER_ID = "ContextBarCanvas";

class ContextBarCanvas extends PureComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      scrollLeftTs: null,
      unitScale: null
    };
    this.scrollUpdateReceived = this.scrollUpdateReceived.bind(this);
    this.applyTransform = this.applyTransform.bind(this);
  }

  componentDidMount() {
    this.props.registerScrollListener(LISTENER_ID, this.scrollUpdateReceived);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      scrollLeftTs: nextProps.scrollLeftTs,
      unitScale: nextProps.unitScale
    });
  }

  componentWillUnmount() {
    this.props.unregisterScrollListener(LISTENER_ID);
  }

  scrollUpdateReceived(scrollState) {
    if (!isNil(this.state.scrollLeftTs)) {
      const diff = (this.state.scrollLeftTs - scrollState.scrollLeftTs) / this.state.unitScale;
      if (scrollState.unitScale === this.state.unitScale && Math.abs(diff) < TIMELINE_CONTEXT_OVERSCROLL) {
        this.applyTransform(diff);
        return;
      }
    }
    // Fall-through: set internal state so that everything updates correctly!
    this.setState(scrollState.toObject());
  }

  getVisibleRangeAbsolute(props, absoluteLeft, absoluteRight, _unitScale) {
    // Work out the bounds of our currently displayed scroll position
    const renderedLeft = absoluteLeft - TIMELINE_CONTEXT_OVERSCROLL;
    const renderedRight = absoluteRight + TIMELINE_CONTEXT_OVERSCROLL;
    return {
      left: renderedLeft,
      right: renderedRight
    };
  }

  getVisibleRangeRelative(props, absoluteLeft, absoluteRight, unitScale) {
    const range = this.getVisibleRangeAbsolute(props, absoluteLeft, absoluteRight, unitScale);

    // Convert them back to relative pixels
    return {
      left: range.left - absoluteLeft,
      right: range.right - absoluteLeft
    };
  }

  getVisibleLabels(absoluteLeft, absoluteRight, unitScale) {
    // Get absolute positions with padding so we can do the manual scroll thing.
    const range = this.getVisibleRangeAbsolute(this.props, absoluteLeft, absoluteRight, unitScale);

    return selectors.getTimelineContextLabels(
      this.props.calendar,
      this.props.viewIds.get(0),
      unitScale,
      range.left,
      range.right,
      this.props.fontSize
    );
  }

  getVisibleContextEventDots(events, canvasRange, absoluteLeft, absoluteRight, unitScale, fontSize, viewIds) {
    // Get absolute positions with padding so we can do the manual scroll thing.
    const leftPixel = absoluteLeft - TIMELINE_CONTEXT_OVERSCROLL;
    const rightPixel = absoluteRight + TIMELINE_CONTEXT_OVERSCROLL;
    const leftTs = leftPixel * unitScale;
    const rightTs = rightPixel * unitScale;

    const filteredDots = selectors.filterObstructedContextDots(events, unitScale, fontSize, viewIds.first());

    return filteredDots
      .filter(e => e.startTs <= rightTs && e.endTs >= leftTs)
      .map(e => {
        const left = e.startTs / unitScale - absoluteLeft;
        const width = (e.endTs - e.startTs) / unitScale;
        let markerLeft = left;
        let markerWidth = width;

        if (left < leftPixel - absoluteLeft) {
          markerLeft = -1000;
          const leftAdjustment = markerLeft - left;
          markerWidth = width - leftAdjustment;
        }
        if (markerWidth > canvasRange) {
          markerWidth = canvasRange;
        }

        return {
          id: e.id,
          color: e.color,
          left: markerLeft,
          width: markerWidth
        };
      })
      .toArray();
  }

  applyTransform(diff) {
    if (!this._domNode) {
      return;
    }
    this._domNode.style.transform = `translateX(${diff}px)`;
  }

  render() {
    const boundsLeft = this.state.scrollLeftTs / this.state.unitScale;
    const boundsRight = boundsLeft + this.props.containerRect.width;
    const labels = this.state.unitScale
      ? this.getVisibleLabels(boundsLeft, boundsRight, this.state.unitScale)
      : immutableRecords.TimelineHeaderDisplayTicksRecord();

    // Since we may have modified the DOM node behind React's back, set it back to what it should be before we render.
    // We have to actually modify the domNode directly, because we are doing it behind React's back.
    if (this._domNode) {
      this.applyTransform(0);
    }

    const dots = this.state.unitScale
      ? this.getVisibleContextEventDots(
        this.props.events,
        this.props.canvasRange,
        boundsLeft,
        boundsRight,
        this.state.unitScale,
        this.props.fontSize,
        this.props.viewIds
      )
      : [];

    // const contentBounds = this.getVisibleRangeRelative(this.props, boundsLeft, boundsRight, this.state.unitScale);

    // const adjustLabelLeft = boundsLeft + contentBounds.left;
    // const adjustDotLeft = contentBounds.left;

    return (
      <div className="contextBarCanvas" ref={node => (this._domNode = node)} style={{ transform: "translateX(0)" }}>
        {/* <div
          className={`contextBarBoundsBox`}
          style={{
            left: `${contentBounds.left}px`,
            width: `${contentBounds.right - contentBounds.left}px`
          }}
        > */}
        {labels.major.map(t => {
          return (
            <div key={t.pixel} className="majorLabel" style={{ transform: `translateX(${t.pixel - boundsLeft}px)` }}>
              {t.label}
            </div>
          );
        })}
        {dots.map(d => {
          return (
            <div
              key={d.id}
              className={`contextDot ${d.color}`}
              style={{
                transform: `translateX(${d.left}px)`,
                width: `${d.width}px`
              }}
            />
          );
        })}
        {/* </div> */}
      </div>
    );
  }
}

ContextBarCanvas.propTypes = {
  fontSize: PropTypes.number.isRequired,
  calendar: PropTypeShapes.calendar.isRequired,
  viewIds: ImmutablePropTypes.listOf(PropTypes.string).isRequired,
  events: ImmutablePropTypes.listOf(PropTypeShapes.contextEventDotRecord).isRequired,

  scrollLeftTs: PropTypes.number.isRequired,
  unitScale: PropTypes.number.isRequired,

  registerScrollListener: PropTypes.func.isRequired,
  unregisterScrollListener: PropTypes.func.isRequired,
  canvasRange: PropTypes.number.isRequired,

  // From containerContext
  containerRect: PropTypeShapes.flatRect.isRequired
};

export default withContainerContext(ContextBarCanvas);
